module.exports = __webpack_public_path__ + "static/media/login-background.396b82bb.svg";